import React from "react";
import UserHeader from "../components/common/Headers/UserHeader/UserHeader";
import UserFooter from "../components/common/Footer/UserFooter/UserFooter";
// import { Route, Routes } from 'react-router-dom'

const UserLayout = ({ children }) => {
  window.scrollTo(0, 0);
  return (
    <div>
      <UserHeader />
      <div>{children}</div>
      <UserFooter />
    </div>
  );
};

export default UserLayout;
